/**
 * @generated SignedSource<<653fe51ac45ef5a88a05381cc8b0b145>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChangeProjectRoleModal_roles$data = ReadonlyArray<{
  readonly active: boolean;
  readonly id: number;
  readonly name: string;
  readonly " $fragmentType": "ChangeProjectRoleModal_roles";
}>;
export type ChangeProjectRoleModal_roles$key = ReadonlyArray<{
  readonly " $data"?: ChangeProjectRoleModal_roles$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChangeProjectRoleModal_roles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ChangeProjectRoleModal_roles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    }
  ],
  "type": "roles",
  "abstractKey": null
};

(node as any).hash = "7be140e2882b4be6e9cc396d5de2306b";

export default node;
